



































































































































import { RouterNames } from "@/router/routernames";
import { form_item } from "@/shared/dtos/dinamically_forms/form_item";
import { tipo_de_dato } from "@/shared/dtos/dynamic_tables/tipo_de_dato";
import { MessageService } from "@/shared/services/message-service";
import dinamically_formModule from "@/store/modules/dinamically_form-module";
import form_itemModule from "@/store/modules/form_item-module";
import pantalla_modo_listaModule from "@/store/modules/pantalla_modo_lista-module";
import publicModule from "@/store/modules/public-module";
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    MaterialCard: () => import("@/components/Cards/MaterialCard.vue"),
    Xbtn: () => import("@/components/buttons/x-btn.vue"),
    HTMLEditor: () => import("@/components/html-editor/html-editor.vue"),
  },
  $_veeValidate: { validator: "new" },
})
export default class create_dynamic_Fromulario extends Vue {
  public datos_lista: tipo_de_dato[] = [];
  async created() {
    await dinamically_formModule
      .getdinamically_all_form(this.$route.params.id)
      .catch(() => {});

    if (this.is_new()) {
      this.datasource.dinamically_FormDto.BotonGuardar = true;
      this.datasource.dinamically_FormDto.BotonCancelar = true;
      this.datasource.dinamically_FormDto.AutoSaveData = true;
    }

    this.datos_lista = await pantalla_modo_listaModule.getTiposDatos();
  }
  public get controllers() {
    return publicModule.getController_api();
  }

  public get datasource() {
    return dinamically_formModule.dinamically_all_form;
  }

  public get headers() {
    return [
      {
        text: "id",
        value: "id",
      },
      ,
      { text: "Nombre", value: "caption" },
      { text: "Data bilding", value: "variableName" },
      { text: "Orden", value: "orden" },
      {
        text: "Tipo de dato",
        value: "datatype",
      },
      { text: "Pantalla", value: "id_dinamically_form" },
      { text: "Actions", value: "actions" },
    ];
  }

  update_column(form: form_item) {
    form_itemModule.modificarform_item(form);
  }

  async cancel_column(form: form_item) {
    let index = this.datasource.form_items.findIndex((x) => x.id === form.id);
    this.$set(
      this.datasource.form_items,
      index,
      await form_itemModule.getform_item(form.id)
    );
  }
  created_automatic_column() {
    pantalla_modo_listaModule
      .getColumnas(this.datasource.dinamically_FormDto.api_call)
      .then(async (x) => {
        //{ Clave: string; Valor: any }

        for (let index = 0; index < x.length; index++) {
          const element = x[index];

          let form = new form_item({
            variableName: element.Clave,
            caption: element.Clave,
            visible: true,
            estado: true,
            maxLength: 100,
            intab: 1,
            orden: this.datasource.form_items.length + 1,
            datatype: "string",
            id_dinamically_form: this.$route.params.id,
          });

          form_itemModule.guardarform_item(form).then((x) => {
            this.datasource.form_items.push(x);
          });
        }
      });
  }
  add_column(columna: form_item) {
    form_itemModule.guardarform_item(columna);
  }
  async add_new_column() {
    let form = new form_item({
      variableName: "",
      caption: "",
      visible: true,
      estado: true,
      maxLength: 100,
      intab: 1,
      orden: this.datasource.form_items.length + 1,
      datatype: "string",
      id_dinamically_form: this.$route.params.id,
    });

    form_itemModule.guardarform_item(form).then((x) => {
      this.datasource.form_items.push(x);
    });
  }

  public is_new() {
    return Number.parseInt(this.$route.params.id) === -1;
  }

  public aceptar() {
    this.$validator.validateAll().then((allOk) => {
      if (allOk) {
        if (this.is_new()) {
          this.datasource.dinamically_FormDto.id = this.$route.params.id;
          dinamically_formModule
            .guardar_modificardinamically_form(this.datasource)
            .then(() => this.cancelar());
        } else {
          dinamically_formModule
            .guardar_modificardinamically_form(this.datasource)
            .then(() => this.cancelar());
        }
      }
    });
  }

  public cancelar() {
    this.$router.back();
  }

  delete_column(campo: form_item) {
    MessageService.confirm(
      "¿Seguro que desea eliminar el campo " + campo.caption + "?",
      "Eliminar",
      (cb: boolean) => {
        if (cb) {
          form_itemModule.eliminarform_item(campo).then(() => {
            var index = this.datasource.form_items.findIndex(
              (x) => x.id === campo.id
            );
            dinamically_formModule.eliminarPantallaModoLista(index);
            dinamically_formModule
              .getdinamically_all_form(this.$route.params.id)
              .catch(() => {});
          });
        }
      }
    );
  }

  eliminar() {
    MessageService.confirm(
      "¿Seguro que desea eliminar?",
      "Eliminar",
      (cb: boolean) => {
        if (cb) {
          /*dinamically_formModule.eliminarpantalla_modo_lista(
            Number.parseInt(this.$route.params.id)
          );*/
        }
      }
    );
  }
}
